import React, {
  createRef,
  useState,
  useEffect,
  useRef,
  forwardRef
} from 'react';
import ReactDOM from 'react-dom';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment-timezone';
import ButtonLoad from '../ButtonLoad';
import RecurrentPosts from '../RecurrentPosts';
import Picker from 'emoji-picker-react';
import EditImgModal from '../EditImgModal';
import S3 from 'react-aws-s3';
import { v4 as uuidv4 } from 'uuid';
// image-size/http/url removed — not compatible with browser/webpack 5
import { MANIPULATE_DESCRIPTION } from '../../utils';
import { authSelector } from '../../store/slices/auth';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';
import { Button as DialogButton } from '../ui/button';

import Clock from 'react-live-clock';
import { cloneDeep } from 'lodash';
import {
  API_POSTS,
  API_ASSETS,
  API_POSTS_EDIT,
  API_POSTS_REPAIR,
  S3_GET_PRESIGNED_URLS,
  GENERATE_TEXT_FROM_IMAGE
} from '../../utils';

import { AWS_BUCKET_MMS } from '../../utils/constants';

import { allowedEmails } from '../../utils';
import './NewPost.scss';
import IGTagsPost from '../IGTags/IGTagsPost';
import TabMenu from '../../pages/Calendar/GallerySection/MenuGallery/TabMenu';
import UserGallery from '../../pages/Calendar/GallerySection/UserGallery';
import GoogleGallery from '../../pages/Calendar/GallerySection/GoogleGallery';
import YelpGallery from '../../pages/Calendar/GallerySection/YelpGallery.js';
import Pixabay from '../../pages/Calendar/GallerySection/StockImagesComponents/Pixabay';
import Freepik from '../../pages/Calendar/GallerySection/StockImagesComponents/Freepik';
import { SearchContext } from '../../contexts/SearchContext';

import ContentGallery from '../../pages/Calendar/GallerySection/ContentGallery';
import ClientGallery from '../../pages/Calendar/GallerySection/ClientGallery';
import GoogleBusinessGallery from '../../pages/Calendar/GallerySection/GoogleBusinessGallery';
import OfferModal from './OfferPost/OfferModal';
const reactStringReplace = require('react-string-replace');
const axios = require('axios');

const NewPost = forwardRef((props, ref) => {
  const { isAuthenticated, userInfo } = useSelector(authSelector);
  const currentEmail = userInfo?.email;
  const currentRole = userInfo?.role;
  const [date, setDate] = useState(null);
  const [post, setPost] = useState({
    socialNetworks: {
      facebook: false,
      twitter: false,
      googleMyBusiness: false,
      instagram: false
    }
  });
  const [selectedImagePK, setSelectedImagePK] = useState(null);
  const [selectedImageSK, setSelectedImageSK] = useState(null);
  const [assetUrl, setAssetUrl] = useState({
    value: ''
  });

  const [savingPost, setSavingPost] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);
  const [repairingPost, setRepairingPost] = useState(false);
  const [preview, setPreview] = useState(null);
  const [showRecurrent, setShowRecurrent] = useState(false);
  const [checked, setChecked] = useState(false);
  const [recurrentDates, setRecurrentDates] = useState([]);
  const [isCustomTime, setIsCustomTime] = useState(false);
  const [postDescription, setPostDescription] = useState('');
  const [showEmojisMenu, setShowEmojisMenu] = useState(false);
  const [showImgEditModal, setShowImgEditModal] = useState(false);
  const [croppedImg, setCroppedImg] = useState(null);
  const [isGeneratingText, setIsGeneratingText] = useState(false);
  const [hasSelectedImage, setHasSelectedImage] = useState(false);
  const [textAreaCursorPostion, setTextAreaCursorPostion] = useState({
    selectionStart: 0,
    selectionEnd: 0
  });
  const [allUrls, setAllUrls] = useState([]);
  const [des, setDes] = useState(null);
  // const [used, setUsed] = useState(null);
  const [urlImg, setUrlImg] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [tagsig, setTagsig] = useState('');
  const [imgurlig, setImgurlig] = useState('');
  const assetAttached = useRef(null);
  const [bestTime, setBestTime] = useState(null);
  const modalDismiss = useRef(null);
  const resetForm = useRef(null);
  const message = useRef(null);
  const checkFb = useRef(null);
  const checkGmb = useRef(null);
  const checkTw = useRef(null);
  const checkIg = useRef(null);
  const [query, setQuery] = useState('');
  const [isPromotional, setIsPromotional] = useState(false);
  const [isOffer, setIsOffer] = useState(false);
  const [isOriginalVisible, setIsOriginalVisible] = useState(true);

  // Modal states
  const [imageTooSmallModalOpen, setImageTooSmallModalOpen] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0
  });
  const [postSentSuccessModalOpen, setPostSentSuccessModalOpen] =
    useState(false);
  const [postErrorModalOpen, setPostErrorModalOpen] = useState(false);
  const [noMessageErrorModalOpen, setNoMessageErrorModalOpen] = useState(false);
  const [messageValidationErrorModalOpen, setMessageValidationErrorModalOpen] =
    useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');
  const [noImageErrorModalOpen, setNoImageErrorModalOpen] = useState(false);
  const [noImageSelectedErrorModalOpen, setNoImageSelectedErrorModalOpen] =
    useState(false);
  const [textGenerationErrorModalOpen, setTextGenerationErrorModalOpen] =
    useState(false);
  const [invalidUrlErrorModalOpen, setInvalidUrlErrorModalOpen] =
    useState(false);

  let tagsPhrasesRef = useRef(null);
  let btnTagRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  let days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  useEffect(() => {
    if (savingPost || savingDraft || repairingPost) {
      savePost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savingDraft, savingPost, repairingPost]);

  useEffect(() => {
    if (props.post && !props.post.status) {
      if (
        props.post.start.getDate() ===
        getTime(props.currentClientTimeZone).getDate()
      )
        setDate(getTime(props.currentClientTimeZone));
      else {
        setDate(props.post.start);
      }
    } else if (props.post && props.post.status) {
      setIsCustomTime(true);

      if (typeof props.post.start === 'number') {
        setDate(new Date(props.post.start * 1000));
      } else {
        setDate(new Date(props.post.start));
      }

      let post = cloneDeep(props.post);
      let start = props.post ? new Date(props.post.start * 1000) : new Date();

      if (typeof start == 'number') {
        start = new Date(start * 1000);
      }

      if (message.current) {
        message.current.value = post['title'];
      }
      setPostDescription(post.title);
      setAssetUrl({
        value: post['images'] !== undefined ? post['images'][0]['url'] : ''
      });

      let { googleMyBusiness, facebook, twitter, instagram } = false;

      if (props.post && props.post.socialNetworks) {
        const { hashtagsig } = props.post;
        if (hashtagsig) {
          setTagsig(hashtagsig);
        }
        if (props.post.socialNetworks.googleMyBusiness) {
          googleMyBusiness = true;
        }
        if (props.post.socialNetworks.facebook) {
          facebook = true;
        }
        if (props.post.socialNetworks.twitter) {
          twitter = true;
        }
        if (props.post.socialNetworks.instagram) {
          instagram = true;
        }
      } else {
        if (props.currentClientSocialNetworks.googleMyBusiness) {
          googleMyBusiness = true;
        }
        if (props.currentClientSocialNetworks.facebook) {
          facebook = true;
        }
        if (props.currentClientSocialNetworks.twitter) {
          twitter = true;
        }
        if (props.currentClientSocialNetworks.instagram) {
          instagram = true;
        }
      }

      post['socialNetworks'] = {
        googleMyBusiness,
        facebook,
        twitter,
        instagram
      };
      setPost(post);

      if (date && !isCustomTime) {
        setDate(
          new Date(
            start.setHours(
              parseInt(props.currentClientBestTimes[days[start.getDay()]]),
              Math.random() * 59
            )
          )
        );
      }
      if (
        date !== null &&
        date !== props.post.start &&
        props.post.title === ''
      ) {
        setIsCustomTime(false);
      }

      post['images'] ? setPreview(post['images'][0]['url']) : setPreview('');
    } else if (
      !props.isCalendar &&
      props.show &&
      (date === null || bestTime === null) &&
      props.currentClientId
    ) {
      let noCalendarDate = getTime(props.currentClientTimeZone);
      setDate(getTime(props.currentClientTimeZone));
      setBestTime(
        new Date(
          noCalendarDate.setHours(
            parseInt(
              props.currentClientBestTimes[days[noCalendarDate.getDay()]]
            ),
            Math.random() * 59
          )
        )
      );
    }
    if (bestTime === null && props.post) {
      let start = props.post ? props.post.start : new Date();
      if (typeof start === 'number') {
        start = new Date(start);
      }

      let temp_date = start;
      setBestTime(
        new Date(
          temp_date.setHours(
            parseInt(props.currentClientBestTimes[days[temp_date.getDay()]]),
            Math.random() * 59
          )
        )
      );
    }
  }, [
    bestTime,
    date,
    days,
    isCustomTime,
    message,
    props.currentClientBestTimes,
    props.currentClientId,
    props.currentClientSocialNetworks.facebook,
    props.currentClientSocialNetworks.googleMyBusiness,
    props.currentClientSocialNetworks.instagram,
    props.currentClientSocialNetworks.twitter,
    props.currentClientTimeZone,
    props.isCalendar,
    props.post,
    props.show
  ]);
  useEffect(() => {
    const googleMyBusiness =
      props.currentClientSocialNetworks.googleMyBusiness || false;
    const facebook = props.currentClientSocialNetworks.facebook || false;
    const twitter = props.currentClientSocialNetworks.twitter || false;
    const instagram = props.currentClientSocialNetworks.instagram || false;

    setPost((prevPost) => ({
      ...prevPost,
      socialNetworks: {
        googleMyBusiness,
        facebook,
        twitter,
        instagram
      }
    }));
  }, [props.currentClientSocialNetworks]);

  const checkMessageAndReplaceTags = (message) => {
    let newMessage = message;
    let error = '';
    let mergeFields = props.currentClientMergeFields;

    // ====================== Check ~Name ======================

    if (/~Name/i.test(newMessage)) {
      if (mergeFields['~Name'].trim().length === 0) {
        error = 'The ~Name tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~Name)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~Name']))
        );
      }
    }

    // ====================== Check ~Address ===================

    if (/~Address/i.test(newMessage)) {
      if (mergeFields['~Address'].trim().length === 0) {
        error = 'The ~Address tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~Address)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~Address']))
        );
      }
    }

    // ====================== Check ~City ======================

    if (/~City/i.test(newMessage)) {
      if (mergeFields['~City'].trim().length === 0) {
        error = 'The ~City tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~City)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~City']))
        );
      }
    }

    // ====================== Check ~Phone ======================

    if (/~Phone/i.test(newMessage)) {
      if (mergeFields['~Phone'].trim().length === 0) {
        error = 'The ~Phone tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~Phone)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~Phone']))
        );
      }
    }

    // ====================== Check ~Website =======================

    if (/~Website/i.test(newMessage)) {
      if (
        typeof mergeFields['~Website'] == 'undefined' ||
        mergeFields['~Website'].trim().length === 0
      ) {
        error = 'The ~Website tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~Website)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~Website']))
        );
      }
    }

    // ====================== Check ~BestDish =====================

    if (/~BestDish/i.test(newMessage)) {
      if (mergeFields['~BestDish'].trim().length === 0) {
        error = 'The ~BestDish tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~BestDish)/i,
          (match) =>
            (newMessage = newMessage.replace(match, mergeFields['~BestDish']))
        );
      }
    }

    // ====================== Check ~BestService ===================

    if (/~BestService/i.test(newMessage)) {
      if (mergeFields['~BestService'].trim().length === 0) {
        error = 'The ~BestService tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~BestService)/i,
          (match) =>
            (newMessage = newMessage.replace(
              match,
              mergeFields['~BestService']
            ))
        );
      }
    }

    // ====================== Check ~BestProduct ====================

    if (/~BestProduct/i.test(newMessage)) {
      if (mergeFields['~BestProduct'].trim().length === 0) {
        error = 'The ~BestProduct tag has not been assigned.';
        return { status: true, message: error };
      } else {
        reactStringReplace(
          newMessage,
          /(~BestProduct)/i,
          (match) =>
            (newMessage = newMessage.replace(
              match,
              mergeFields['~BestProduct']
            ))
        );
      }
    }

    // ======================== Check ~ Tag ================================

    if (/~/.test(newMessage)) {
      error = 'Invalid ~ tag.';
      return { status: true, message: error };
    }

    return { status: false, message: newMessage };
  };
  const editTimeRecurrentDates = (RecurrentPosts, currentClientTimeZone) => {
    // TIME ZONE - TIME PUBLICATION + TIME LOCATION OR NAVIGATOR
    let timeZone = currentClientTimeZone;
    let timeZoneToUnix = moment(getTime(timeZone)).seconds(0).unix();
    let timeLocation = moment(new Date()).seconds(0).unix();
    const posts = RecurrentPosts.map((item) => {
      return Math.abs(timeZoneToUnix - item) + timeLocation;
    });

    return posts;
  };
  const saveCurrent = () => {
    setSavingPost(true);
  };
  const saveDraft = () => {
    setSavingDraft(true);
  };
  const repairPost = () => {
    setRepairingPost(true);
  };

  const addPost = async (post) => {
    if (post['images']) {
      let dimensions = await getSize(post['images'][0]['url']);

      if (dimensions.height < 250 || dimensions.width < 250) {
        setImageDimensions({
          width: dimensions.width,
          height: dimensions.height
        });
        setImageTooSmallModalOpen(true);
        setSavingPost(false);
        setSavingDraft(false);
        setRepairingPost(false);
        return;
      }
    }

    let clientId =
      post['client'] !== undefined
        ? post['client']['id']
        : props['currentClientId'];

    if (clientId === undefined) {
      return;
    }

    function setGooglePostType(post, type) {
      post[type] = true;
      post['facebook'] = false;
      post['twitter'] = false;
      post['instagram'] = false;
      post['googleMyBusiness'] = true;
    }

    if (isPromotional) {
      setGooglePostType(post, 'isPromotional');
    }

    if (isOffer) {
      setGooglePostType(post, 'isOffer');
    }

    const postBody = {
      message: post['title'],
      images: post['images'],
      schedule: post['start'], //unix UTC
      createdAt: moment.utc().unix(), //unix UTC
      socialNetworks: {
        facebook: post['facebook'] || false,
        twitter: post['twitter'] || false,
        googleMyBusiness: post['googleMyBusiness'] || false,
        instagram: post['instagram'] || false
      },
      isDraft: post['isDraft'],
      recurrentDates: recurrentDates,
      posted: false,
      isScheduled: false,
      createdBy: props.currentCustomerName,
      hashtagsig: post['hashtagsig'],
      isPromotional: post['isPromotional'] || false,
      isOffer: post['isOffer'] || false
    };
    postBody['clientId'] = clientId;
    if (post['id'] !== undefined) {
      postBody['postId'] = post['id'];
    }

    let url = post['id'] !== undefined ? API_POSTS_EDIT : API_POSTS;

    if (repairingPost) {
      url = API_POSTS_REPAIR;
    }

    axios
      .post(url, JSON.stringify(postBody))
      .then(async (response) => {
        if (response) {
          if (selectedImagePK && selectedImageSK && !urlImg) {
            let img_info = {
              ...(selectedImagePK && { PK: selectedImagePK }),
              ...(selectedImageSK && { SK: selectedImageSK }),
              isUsed: true
            };
            await fetch(MANIPULATE_DESCRIPTION, {
              method: 'POST',
              body: JSON.stringify(img_info),
              headers: {
                'Content-Type': 'application/json'
              }
            });
          }
          if (urlImg) {
            let img_info = {
              userid: props.currentClientId,
              link: urlImg,
              des: des,
              isUsed: true
            };

            await fetch(MANIPULATE_DESCRIPTION, {
              method: 'POST',
              body: JSON.stringify(img_info),
              headers: {
                'Content-Type': 'application/json'
              }
            });
          }
          if (urlImg) {
            setRefresh(!refresh);
          }
          let temp_used_state = urlImg;
          // setDate(null); // TEST IF IT WORKS
          setPost({
            socialNetworks: {
              facebook: true,
              twitter: true,
              googleMyBusiness: true,
              instagram: true
            }
          });
          setAssetUrl({
            value: ''
          });
          setSavingPost(false);
          setSavingDraft(false);
          setRepairingPost(false);
          setPreview(null);
          setHasSelectedImage(false);
          setIsGeneratingText(false);
          setShowRecurrent(false);
          setChecked(false);
          setRecurrentDates([]);
          setIsCustomTime(false);
          setPostDescription('');
          setShowEmojisMenu(false);
          setShowImgEditModal(false);
          setCroppedImg(null);
          setTextAreaCursorPostion({
            selectionStart: 0,
            selectionEnd: 0
          });
          setAllUrls([]);
          setDes(null);
          setIsPromotional(false);
          setIsOffer(false);
          setUrlImg(null);
          setRefresh(false);
          setTagsig('');
          setImgurlig('');
          setBestTime(null);
          setPostSentSuccessModalOpen(true);

          if (resetForm.current) resetForm.current.click();
          if (modalDismiss.current) modalDismiss.current.click();
          if (props?.callbackClose) {
            props.callBackClose();
          }

          if (props.callbackPost) {
            props.callbackPost(response, temp_used_state);
          }
        }
      })
      .catch((error) => {
        if (error) {
          setPostErrorModalOpen(true);
          setSavingPost(false);
        }
        console.error(error);
      });
  };
  const savePost = () => {
    // setSavingPost(true);

    // ====================== Check a Message ======================

    // ========== Length ==========

    if (!message.current || message.current.value.length < 3) {
      if (message.current) {
        message.current.className = 'form-control error-field';
        message.current.placeholder = 'This field is required';
      }

      setNoMessageErrorModalOpen(true);
      setSavingPost(false);
      setSavingDraft(false);
      setRepairingPost(false);
      return;
    }

    // ========== Tags =============

    if (postDescription.includes('~')) {
      let checkMessage = checkMessageAndReplaceTags(postDescription);

      if (checkMessage.status) {
        setValidationErrorMessage(checkMessage.message);
        setMessageValidationErrorModalOpen(true);
        setSavingPost(false);
        setSavingDraft(false);
        setRepairingPost(false);
        return;
      } else {
        setPostDescription(checkMessage.message);
        if (message.current) {
          message.current.value = checkMessage.message;
        }
      }
    }

    // ====================== Check a Image ==========================

    if (
      assetUrl.value.length === 0 &&
      (!assetAttached.current || assetAttached.current.files.length === 0) &&
      !savingDraft
    ) {
      setNoImageErrorModalOpen(true);
      setSavingPost(false);
      setSavingDraft(false);
      return;
    }

    allUrls.map((url) => {
      return url.replace('/thumbnails', '');
    });
    // let temp_used = originalUrls.includes(assetUrl.value);
    // setUsed(temp_used);
    if (savingDraft) {
      if (croppedImg) {
        detectPost(3);
      } else if (
        assetUrl.value.length === 0 &&
        assetAttached.files[0] === undefined
      ) {
        uploadPost('', 0);
      } else if (assetAttached.files[0] !== undefined) {
        detectPost(2);
      } else if (
        assetUrl.value !== '' ||
        assetUrl.value !== post['images'][0]['url']
      ) {
        detectPost(1);
      }
    } else {
      if (croppedImg) {
        detectPost(3);
      } else if (assetAttached.files[0] !== undefined) {
        detectPost(2);
      } else if (
        assetUrl.value !== '' ||
        assetUrl.value !== post['images'][0]['url']
      ) {
        detectPost(1);
      }
    }
  };

  const detectPost = async (flag) => {
    let bodyLoadImage = {
      clientId: props.currentClientId
    };
    console.log(`flag: ${flag}`);
    switch (flag) {
      case 1:
        bodyLoadImage['urlFile'] = assetUrl.value;
        uploadImage(bodyLoadImage, flag);
        break;
      case 2:
        fileToBase64(assetAttached, (res) => {
          bodyLoadImage['fileB64'] = res;
          uploadImage(bodyLoadImage, flag);
        });
        break;
      case 3:
        blobToBase64(croppedImg, (res) => {
          bodyLoadImage['fileB64'] = res;
          uploadImage(bodyLoadImage, flag);
        });
        break;
      default:
        break;
    }
  };

  const selectSn = (key, val) => {
    if (post['socialNetworks']) {
      setPost((prevPost) => ({
        ...prevPost,
        socialNetworks: {
          ...prevPost.socialNetworks,
          [key]: !prevPost.socialNetworks[key]
        }
      }));
    }
  };
  const uploadPost = (urlImage, flag) => {
    let post1 = post;
    let timeZone = getTime(props.currentClientTimeZone);
    let rest = null;
    if (isCustomTime) {
      rest = moment.utc(timeZone).unix() - moment.utc(date).unix();
    } else if (!isCustomTime && bestTime !== null) {
      rest = moment.utc(timeZone).unix() - moment.utc(bestTime).unix();
    } else {
      rest = moment.utc(timeZone).unix() - moment.utc(date).unix();
    }
    let dateNow =
      (rest > 0 ? -600 : rest * -1) + moment.utc(new Date()).seconds(0).unix();

    post1['title'] = message.current ? message.current.value : '';
    post1['start'] = dateNow;
    if (urlImage !== '') {
      post1['images'] = [
        { url: urlImage, text: urlImage.split('.com/')[1].split('.')[0] || '' }
      ];

      if (flag === 1) {
        post1['images'][0]['originalURL'] = preview;
      }
    }

    let tagsText = '';
    if (tagsPhrasesRef.current !== null) {
      const phrasesTags = Array.from(tagsPhrasesRef.current.childNodes);

      tagsText = phrasesTags.map((nodes) => {
        return nodes['childNodes'][0].data;
      });

      tagsText = tagsText.join('-n-');
    }

    post1['facebook'] = checkFb.current ? checkFb.current.checked : false;
    post1['twitter'] = checkTw.current ? checkTw.current.checked : false;
    post1['isDraft'] = savingDraft ? true : false;
    post1['googleMyBusiness'] = checkGmb.current
      ? checkGmb.current.checked
      : false;
    post1['instagram'] = checkIg.current ? checkIg.current.checked : false;
    post1['startEditable'] = true;
    post1['backgroundColor'] = '#039be5';
    post1['borderColor'] = '#0168fa';
    post1['textColor'] = '#fff';
    post1['imgurlig'] = imgurlig;
    post1['hashtagsig'] = tagsText;
    addPost(post1);
  };

  const uploadImage = async (bodyLoadImage, flag) => {
    if (flag === 2) {
      if (!assetAttached.current || !assetAttached.current.files[0]) {
        return;
      }
      let file = assetAttached.current.files[0];

      try {
        const mimeType = '.' + file?.name.split('.').pop() || '.jpg';
        let newFileName = `${uuidv4()}${mimeType}`;
        const fileType = file?.type;
        console.log(`fileType: ${fileType}`);
        // 1. Obtener la URL prefirmada desde tu API Gateway
        const presignedResponse = await fetch(S3_GET_PRESIGNED_URLS, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            bucketName: 'adlersuite-assets-prod',
            files: [{ fileName: newFileName, fileType }]
          })
        });

        if (!presignedResponse.ok) {
          throw new Error('Failed to get presigned URL');
        }

        const { urls } = await presignedResponse.json();
        const presignedUrl = urls?.[0]?.url;

        if (!presignedUrl) {
          throw new Error('No presigned URL returned');
        }

        // 2. Subir el archivo directamente a S3
        const uploadResult = await fetch(presignedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': fileType
          },
          body: file
        });

        if (!uploadResult.ok) {
          throw new Error('File upload to S3 failed');
        }

        if (!uploadResult.ok) {
          setInvalidUrlErrorModalOpen(true);
          assetUrl.value = '';
          setSavingPost(false);
        }
        const uploadedFileUrl = `https://${'adlersuite-assets-prod'}.s3.amazonaws.com/${newFileName}`;
        setAssetUrl({ value: uploadedFileUrl });
        uploadPost(uploadedFileUrl, flag);
        console.log(`File uploaded successfully: ${uploadedFileUrl}`);
      } catch (error) {
        console.error('Upload failed:', error);
      }
    } else {
      axios
        .post(API_ASSETS, bodyLoadImage)
        .then((response) => {
          if (response['data']['Location']) {
            let res =
              response['data']['Location'].substring(
                0,
                response['data']['Location'].lastIndexOf('.')
              ) + '.jpeg';
            setAssetUrl({ value: res });
            uploadPost(res, flag);
          }
        })
        .catch((error) => {
          setInvalidUrlErrorModalOpen(true);
          setAssetUrl({ value: '' });
          setSavingPost(false);
        });
    }
  };
  const onChange = (date) => {
    if (date instanceof Date) {
      setDate(date);
    }
  };

  const handleRecurrentCheck = () => {
    setShowRecurrent(!showRecurrent);

    setRecurrentDates(date);
    setChecked(!checked);
  };

  const handleCustomTime = () => {
    //PENDING
    setIsCustomTime(!isCustomTime);
    if (!isCustomTime) {
      let temp_date = cloneDeep(date);

      setBestTime(
        new Date(
          temp_date.setHours(
            parseInt(props.currentClientBestTimes[days[temp_date.getDay()]]),
            Math.random() * 59
          )
        )
      );
    } else {
      // POST SCHEDULE
      if (!props.isCalendar) {
        setDate(getTime(props.currentClientTimeZone));
      } else {
        if (props.post && props.post.status) {
          // setDate(editDate);
        } else {
          // setDate(date);
          // setBestTime(
          //   new Date(
          //     date.setHours(
          //       parseInt(props.currentClientBestTimes[days[date.getDay()]]),
          //       Math.random() * 59
          //     )
          //   )
          // );
        }
      }
    }
  };
  const setAppImage = (event) => {
    handlePreview(event);
    setHasSelectedImage(true);
  };
  const checkImg = (param) => {
    //if (allUrls.length < 1) {
    let urlOriginal = param[1];
    let thumbUrl = urlOriginal.split('/');

    urlOriginal = `${thumbUrl[0]}//${thumbUrl[2]}/${thumbUrl[3]}/${thumbUrl[4]}/thumbnails/${thumbUrl[5]}`;
    setAllUrls(param[0]);
    setUrlImg(urlOriginal);
    setDes(param[2]);
    //}
  };

  const handlePreview = (event) => {
    setAssetUrl({ value: event.target.value });
    event.target.files
      ? setPreview(URL.createObjectURL(event.target.files[0]))
      : setPreview(event.target.value);
  };

  const handleSelectImage = (param) => {
    setHasSelectedImage(true);
    if (param && param.pk && param.sk) {
      setSelectedImagePK(param.pk);
      setSelectedImageSK(param.sk);
      setAssetUrl({ value: param.sk });
      setPreview(param.sk);
    } else if (Array.isArray(param) && param.length === 3) {
      checkImg(param);
      setSelectedImagePK(null);
      setSelectedImageSK(null);
    } else {
      setAppImage(param);
      setSelectedImagePK(null);
      setSelectedImageSK(null);
    }
  };

  const getSize = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = (err) => reject(err);
      img.crossOrigin = 'anonymous';
      img.src = imageUrl;
    });
  };

  const generateTextFromImage = async () => {
    console.log('Generando texto a partir de la imagen...');
    if (!preview && !croppedImg) {
      setNoImageSelectedErrorModalOpen(true);
      return;
    }

    setIsGeneratingText(true);

    try {
      const imageUrl = croppedImg || preview;

      // Determinar la fecha a enviar
      let selectedDate = null;
      if (isCustomTime && date) {
        selectedDate = date;
      } else if (bestTime) {
        selectedDate = bestTime;
      } else if (date) {
        selectedDate = date;
      }

      // Formatear la fecha a DD/MM/YYYY
      let formattedDate = null;
      if (selectedDate) {
        const day = String(selectedDate.getDate()).padStart(2, '0');
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const year = selectedDate.getFullYear();
        formattedDate = `${day}/${month}/${year}`;
      }
      console.log('Fecha formateada a enviar:', formattedDate);

      // Primero obtener la descripción de la imagen si existe
      let imageDescripcion = '';
      try {
        const descriptionConfig = {
          method: 'post',
          url: MANIPULATE_DESCRIPTION,
          data: {
            userid: props.currentClientId,
            get: true,
            to_suite: true
          }
        };

        const descriptionResponse = await axios(descriptionConfig);
        if (descriptionResponse.data?.images) {
          console.log(
            'Descripción de imágenes obtenida:',
            descriptionResponse.data.images
          );
          const imageDescriptions = descriptionResponse.data.images;

          // Buscar la descripción de la imagen actual
          // Probar tanto con la URL original como con la URL de thumbnail
          if (typeof imageDescriptions[imageUrl] === 'object') {
            imageDescripcion = imageDescriptions[imageUrl]?.description || '';
          } else if (typeof imageDescriptions[imageUrl] === 'string') {
            imageDescripcion = imageDescriptions[imageUrl] || '';
          } else {
            // Intentar con la URL de thumbnail si la URL original no tiene descripción
            const thumbnailUrl = imageUrl.includes('/thumbnails/')
              ? imageUrl
              : imageUrl.replace(/\/([^\/]+)$/, '/thumbnails/$1');

            if (typeof imageDescriptions[thumbnailUrl] === 'object') {
              imageDescripcion =
                imageDescriptions[thumbnailUrl]?.description || '';
            } else if (typeof imageDescriptions[thumbnailUrl] === 'string') {
              imageDescripcion = imageDescriptions[thumbnailUrl] || '';
            }
          }
        }
      } catch (descError) {
        console.error('Error fetching image description:', descError);
        // Continuar sin descripción si hay error
      }

      // Reemplaza esta URL con tu endpoint real
      const response = await fetch(GENERATE_TEXT_FROM_IMAGE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          imageUrl: imageUrl,
          clientId: props.currentClientId,
          scheduledDate: formattedDate,
          imageDescripcion: imageDescripcion
        })
      });

      if (!response.ok) {
        throw new Error('Error generating text');
      }

      const data = await response.json();

      if (data.socialMediaText) {
        setPostDescription(data.socialMediaText);
        // También actualizar el valor del textarea
        if (message.current) {
          message.current.value = data.socialMediaText;
        }
      }
    } catch (error) {
      console.error('Error generating text:', error);
      setTextGenerationErrorModalOpen(true);
    } finally {
      setIsGeneratingText(false);
    }
  };

  const getTime = (currentClientTimeZone) => {
    let date = null;

    switch (currentClientTimeZone) {
      case 'Eastern Daylight Time - (GMT-4)':
        date = moment(new Date())
          .tz('America/New_York')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Central Daylight Time - (GMT-5)':
        date = moment(new Date())
          .tz('America/Chicago')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Daylight Time - (GMT-6)':
        date = moment(new Date())
          .tz('America/Denver')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Standard Time - (GMT-7)':
        date = moment(new Date())
          .tz('America/Phoenix')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Pacific Daylight Time - (GMT-7)':
        date = moment(new Date())
          .tz('America/Los_Angeles')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Alaska Daylight Time - (GMT-8)':
        date = moment(new Date())
          .tz('America/Anchorage')
          .format('YYYY-MM-DDTHH:mm');
        break;
      default:
        date = moment(new Date())
          .tz('Pacific/Honolulu')
          .format('YYYY-MM-DDTHH:mm');
        break;
    }

    return new Date(date);
  };

  const renderSocialNetworks = () => {
    const { currentClientSocialNetworks } = props;
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        {currentClientSocialNetworks.facebook && (
          <label className="flex items-center space-x-3 cursor-pointer group">
            <input
              ref={checkFb}
              type="checkbox"
              className="w-4 h-4 border-gray-300 rounded focus:ring-2"
              style={{ accentColor: '#3766a8' }}
              id="customCheckFb"
              onChange={(e) => selectSn('facebook', e.target.value)}
              checked={
                post['socialNetworks'] && post['socialNetworks']['facebook']
              }
            />
            <div className="flex items-center gap-2">
              <i
                className="fab fa-facebook text-blue-600"
                style={{ fontSize: '16px' }}></i>
              <span
                className="text-gray-700 group-hover:text-gray-900"
                style={{ fontSize: '13px' }}>
                Facebook
              </span>
            </div>
          </label>
        )}

        {currentClientSocialNetworks.instagram && (
          <label className="flex items-center space-x-3 cursor-pointer group">
            <input
              ref={checkIg}
              type="checkbox"
              className="w-4 h-4 border-gray-300 rounded focus:ring-2"
              style={{ accentColor: '#3766a8' }}
              id="customCheckIg"
              onChange={(e) => selectSn('instagram', e.target.value)}
              checked={
                post['socialNetworks'] && post['socialNetworks']['instagram']
              }
            />
            <div className="flex items-center gap-2">
              <i
                className="fab fa-instagram text-pink-600"
                style={{ fontSize: '16px' }}></i>
              <span
                className="text-gray-700 group-hover:text-gray-900"
                style={{ fontSize: '13px' }}>
                Instagram
              </span>
            </div>
          </label>
        )}

        {currentClientSocialNetworks.googleMyBusiness && (
          <label className="flex items-center space-x-3 cursor-pointer group">
            <input
              ref={checkGmb}
              type="checkbox"
              className="w-4 h-4 border-gray-300 rounded focus:ring-2"
              style={{ accentColor: '#3766a8' }}
              id="customCheckGmb"
              onChange={(e) => selectSn('googleMyBusiness', e.target.value)}
              checked={
                post['socialNetworks'] &&
                post['socialNetworks']['googleMyBusiness']
              }
            />
            <div className="flex items-center gap-2">
              <i
                className="fab fa-google text-red-600"
                style={{ fontSize: '16px' }}></i>
              <span
                className="text-gray-700 group-hover:text-gray-900"
                style={{ fontSize: '13px' }}>
                Google Business
              </span>
            </div>
          </label>
        )}

        {currentClientSocialNetworks.twitter && (
          <label className="flex items-center space-x-3 cursor-pointer group">
            <input
              ref={checkTw}
              type="checkbox"
              className="w-4 h-4 text-blue-400 border-gray-300 rounded focus:ring-blue-400"
              id="customCheckTw"
              onChange={(e) => selectSn('twitter', e.target.value)}
              checked={
                post['socialNetworks'] && post['socialNetworks']['twitter']
              }
            />
            <div className="flex items-center gap-2">
              <i
                className="fab fa-twitter text-blue-400"
                style={{ fontSize: '16px' }}></i>
              <span
                className="text-gray-700 group-hover:text-gray-900"
                style={{ fontSize: '13px' }}>
                Twitter
              </span>
            </div>
          </label>
        )}
      </div>
    );
  };

  const renderBestTime = () => {
    const { currentClientTimeZone } = props;
    const currentDate = new Date();
    return (
      <div
        className="bg-white border border-gray-200 p-4"
        style={{ borderRadius: '12px' }}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2.5">
            <i
              className="far fa-calendar"
              style={{
                fontSize: '17px',
                color: '#3766a8',
                lineHeight: '1'
              }}></i>
            <h3
              className="font-semibold text-gray-900"
              style={{ fontSize: '17px', lineHeight: '1' }}>
              Schedule Post
            </h3>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              onChange={() => handleCustomTime()}
              checked={isCustomTime}
            />
            <span className="slider round" />
          </label>
        </div>

        {isCustomTime && (
          <div className="space-y-3">
            <div>
              <label
                className="block text-gray-600 mb-2"
                style={{ fontSize: '13px' }}>
                Please select date and time
              </label>
              <DateTimePicker
                onChange={onChange}
                disableClock
                value={date}
                minDate={getTime(currentClientTimeZone)}
                name="postSchedule"
                required
                showTime={{ use12Hours: true }}
                format="dd/MM/yyyy hh:mm a"
                clearIcon={null}
                calendarIcon={null}
                className="w-full"
              />
            </div>

            {date &&
              typeof date !== 'number' &&
              props.currentClientBestTimes &&
              getTime(currentClientTimeZone).getHours() >
                parseInt(props.currentClientBestTimes[days[date.getDay()]]) &&
              date.getDate() === currentDate.getDate() && (
                <div className="flex items-center gap-2 text-xs text-amber-600 bg-amber-50 px-3 py-2 rounded">
                  <i className="fas fa-exclamation-triangle" />
                  <span>Your best time posting has passed</span>
                </div>
              )}

            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                id="recurrentCheck"
                onChange={handleRecurrentCheck}
                checked={checked}
              />
              <span className="text-sm text-gray-700">Recurring post</span>
            </label>

            {showRecurrent && (
              <RecurrentPosts
                date={date}
                recurrentDates={(dates) =>
                  setRecurrentDates(
                    editTimeRecurrentDates(dates, currentClientTimeZone)
                  )
                }
              />
            )}
          </div>
        )}

        {!isCustomTime && bestTime && (
          <div className="text-center py-4">
            <div className="text-sm text-gray-500 mb-1">Best time to post</div>
            <div className="text-2xl font-semibold text-gray-900">
              {bestTime.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderImgUrl = () => (
    <>
      <h5 className="card-title">Image URL</h5>
      <h6 className="card-subtitle mb-2 text-muted">
        Please add an url for an image
      </h6>
      <input
        value={assetUrl.value}
        className="form-control"
        name="assetUrl"
        onChange={handlePreview}
      />
    </>
  );

  const renderImgFile = () => (
    <React.Fragment>
      <h5 className="card-title mt-3">Image File</h5>
      <h6 className="card-subtitle mb-2 text-muted">
        Please add a file for an image
      </h6>
      <input
        type="file"
        ref={assetAttached}
        className="form-control attach-file"
        name="assetUrl"
        onChange={handlePreview}
      />
    </React.Fragment>
  );

  const renderImgPreview = () => (
    <div
      className="card"
      style={{
        maxHeight:
          hasSelectedImage && (croppedImg || preview) ? '16rem' : '13rem',
        border: 'none'
      }}>
      <div className="card-body overflow-hidden">
        <h5 className="card-title">Image Preview</h5>
        <h6 className="card-subtitle mb-2 text-muted">Your Image preview</h6>
        <div className="row">
          <div
            style={{
              backgroundImage: `url(${croppedImg ? croppedImg : preview})`
            }}
            className="img-preview">
            {croppedImg || preview ? '' : <label>No image to preview</label>}
          </div>
          {preview && (
            <div
              className="edit-img-btn shadow"
              onClick={() => {
                setShowImgEditModal(true);
              }}>
              <i className="fa fa-fw fa-pencil-alt" />
            </div>
          )}
        </div>

        {/* Button Generate Automatic Text */}
        {hasSelectedImage && (croppedImg || preview) && (
          <div className="mt-3 text-center">
            <button
              type="button"
              className={`btn btn-sm ${
                isGeneratingText ? 'btn-secondary' : 'btn-primary'
              }`}
              onClick={generateTextFromImage}
              disabled={isGeneratingText}>
              {isGeneratingText ? (
                <>
                  <i className="fa fa-spinner fa-spin mr-1"></i>
                  &nbsp; Generating...
                </>
              ) : (
                <>
                  <i className="fa fa-magic mr-1"></i>
                  &nbsp; Generate Post
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );

  // ================ Drag and Drop Merge Fields Tags ===============

  const onDragStart = (e, key) => {
    e.dataTransfer.setData('key', key);
  };

  const handleClickStart = (e, key) => {
    e.preventDefault();
    setPostDescription(postDescription + key + ' ');
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = (e) => {
    setPostDescription(postDescription + e.dataTransfer.getData('key') + ' ');
  };

  const { currentClientTimeZone, currentClientMergeFields } = props;

  // ====================== Merge Fields Tags ======================
  let mergeFields = [];

  if (currentClientMergeFields) {
    for (let key in currentClientMergeFields) {
      if (
        currentClientMergeFields[key] &&
        currentClientMergeFields[key].trim().length !== 0
      ) {
        mergeFields.push(
          <button
            key={key}
            onClick={(e) => handleClickStart(e, key)}
            onDragStart={(e) => onDragStart(e, key)}
            className="px-2.5 py-0.5 font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer border border-gray-200"
            style={{ fontSize: '11px' }}
            draggable
            type="button">
            {key}
          </button>
        );
      }
    }
  }
  const getTimeZoneClock = (currentClientTimeZone) => {
    let timeZoneClock = null;
    switch (currentClientTimeZone) {
      case 'Eastern Daylight Time - (GMT-4)':
        timeZoneClock = 'America/New_York';
        break;
      case 'Central Daylight Time - (GMT-5)':
        timeZoneClock = 'America/Chicago';
        break;
      case 'Mountain Daylight Time - (GMT-6)':
        timeZoneClock = 'America/Denver';
        break;
      case 'Mountain Standard Time - (GMT-7)':
        timeZoneClock = 'America/Phoenix';
        break;
      case 'Pacific Daylight Time - (GMT-7)':
        timeZoneClock = 'America/Los_Angeles';
        break;
      case 'Alaska Daylight Time - (GMT-8)':
        timeZoneClock = 'America/Anchorage';
        break;
      default:
        timeZoneClock = 'Pacific/Honolulu';
        break;
    }
    return timeZoneClock;
  };

  const [value, setValue] = useState(0);

  const handleIndexChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOfferSwitchChange = () => {
    setIsOriginalVisible(false);
    setIsOffer(true);
  };

  return (
    <>
      {props.show &&
        ReactDOM.createPortal(
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-black/50 z-[1040]"
              onClick={props.onClose}></div>
            {/* Modal */}
            <div
              className={`fixed inset-0 z-[1050] flex items-center justify-center p-4 ${
                !savingPost ? 'disable' : ''
              } ${isOffer ? 'hidden' : ''}`}
              id="newPost"
              role="dialog"
              aria-labelledby="addNewGroupLabel"
              aria-modal="true"
              ref={ref}>
              <div
                id="modal-new-post"
                className="relative w-full max-w-6xl mx-4 bg-white rounded-lg shadow-xl max-h-[90vh] overflow-auto"
                role="document">
                <div
                  className={`${
                    savingPost ? 'pointer-events-none opacity-50' : ''
                  }`}>
                  {/* Header - Sticky */}
                  <div
                    className="sticky top-0 z-10 flex items-center justify-between px-6 py-2.5 bg-white"
                    style={{ borderBottom: '2px solid #e5e7eb' }}>
                    <div className="flex items-center gap-3">
                      <i
                        className="fas fa-file-alt"
                        style={{ fontSize: '24px', color: '#3766a8' }}></i>
                      <div style={{ lineHeight: '1.3' }}>
                        <h2
                          className="font-semibold text-gray-900"
                          style={{
                            fontSize: '15px',
                            marginBottom: '2px'
                          }}></h2>
                        <div
                          className="flex items-center gap-2 text-gray-500"
                          style={{ fontSize: '12px' }}>
                          <i className="far fa-clock"></i>
                          <span>{currentClientTimeZone} • </span>
                          <Clock
                            format={'HH:mm:ss'}
                            ticking={true}
                            timezone={getTimeZoneClock(currentClientTimeZone)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-3">
                      <button
                        type="button"
                        className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                        onClick={() => {
                          props.onClose && props.onClose();
                          if (resetForm.current) resetForm.current.click();
                          if (props?.callbackClose) {
                            props.callBackClose();
                          }
                          setDate(null);
                          setPost({
                            socialNetworks: {
                              facebook: true,
                              twitter: true,
                              googleMyBusiness: true,
                              instagram: true
                            }
                          });
                          setAssetUrl({
                            value: ''
                          });

                          setSavingPost(false);
                          setSavingDraft(false);
                          setPreview(null);
                          setHasSelectedImage(false);
                          setIsGeneratingText(false);
                          setShowRecurrent(false);
                          setChecked(false);
                          setRecurrentDates([]);
                          setIsCustomTime(false);
                          setPostDescription('');
                          setShowEmojisMenu(false);
                          setShowImgEditModal(false);
                          setCroppedImg(null);
                          setTextAreaCursorPostion({
                            selectionStart: 0,
                            selectionEnd: 0
                          });
                          setAllUrls([]);
                          setDes(null);
                          setIsPromotional(false);
                          setIsOffer(false);
                          setUrlImg(null);
                          setRefresh(false);
                          setTagsig('');
                          setImgurlig('');
                          setBestTime(null);
                          setQuery('');
                          setValue(0);
                        }}
                        ref={modalDismiss}>
                        Cancel
                      </button>

                      <button
                        type="button"
                        disabled={savingDraft}
                        style={{
                          color: '#3766a8',
                          backgroundColor: '#eff6ff',
                          borderColor: '#3766a8'
                        }}
                        className="px-4 py-2 border rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50"
                        onClick={() => saveDraft()}>
                        {savingDraft ? (
                          <>
                            <i
                              className="fa fa-spinner fa-spin mr-2"
                              style={{ fontSize: '16px' }}></i>
                            Saving...
                          </>
                        ) : (
                          <>
                            <i
                              className="far fa-save mr-2"
                              style={{ fontSize: '16px' }}></i>
                            Save Draft
                          </>
                        )}
                      </button>

                      {post.isRepairingPost ? (
                        <button
                          type="button"
                          disabled={repairingPost}
                          className="px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
                          style={{ border: 'none' }}
                          onClick={() => repairPost()}>
                          {repairingPost ? (
                            <>
                              <i
                                className="fa fa-spinner fa-spin mr-2"
                                style={{ fontSize: '16px' }}></i>
                              Editing...
                            </>
                          ) : (
                            <>
                              <i
                                className="fas fa-wrench mr-2"
                                style={{ fontSize: '16px' }}></i>
                              Edit Post
                            </>
                          )}
                        </button>
                      ) : (
                        <button
                          type="button"
                          disabled={savingPost}
                          className="px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50"
                          style={{ border: 'none' }}
                          onClick={() => saveCurrent()}>
                          {savingPost ? (
                            <>
                              <i
                                className="fa fa-spinner fa-spin mr-2"
                                style={{ fontSize: '16px' }}></i>
                              Publishing...
                            </>
                          ) : (
                            <>
                              <i
                                className="fas fa-check mr-2"
                                style={{ fontSize: '16px' }}></i>
                              Publish
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>

                  <form
                    style={{
                      maxHeight: 'calc(90vh - 100px)',
                      overflowY: 'auto'
                    }}>
                    <input
                      hidden="true"
                      className="btn-reset"
                      type="reset"
                      ref={resetForm}
                      value="reset"
                    />
                    <div className="p-6" style={{ paddingTop: '16px' }}>
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        {/* Columna Izquierda */}
                        <div className="space-y-4">
                          {/* Post Content + Instagram Tags */}
                          <div
                            className="bg-white border border-gray-200 p-4"
                            style={{ borderRadius: '12px' }}>
                            {/* Post Content Section */}
                            <div className="flex items-baseline gap-2.5 mb-3">
                              <i
                                className="fas fa-file-alt"
                                style={{
                                  fontSize: '17px',
                                  color: '#3766a8',
                                  display: 'inline-flex',
                                  alignItems: 'center'
                                }}></i>
                              <h3
                                className="font-semibold text-gray-900"
                                style={{ fontSize: '17px' }}>
                                Post Content
                              </h3>
                            </div>

                            <div className="mb-4">
                              <div className="flex items-center justify-between mb-2">
                                <label className="text-sm font-medium text-gray-700">
                                  Write your post message here... 😊
                                </label>
                                <div className="flex items-center gap-2">
                                  <span
                                    className={`text-xs ${
                                      checkTw.current?.checked &&
                                      postDescription.length > 280
                                        ? 'text-red-600'
                                        : postDescription.length >= 2000
                                        ? 'text-red-600'
                                        : 'text-gray-500'
                                    }`}>
                                    {checkTw.current?.checked &&
                                      postDescription.length > 280 && (
                                        <span className="mr-1">
                                          Twitter limit •{' '}
                                        </span>
                                      )}
                                    {postDescription.length > 0
                                      ? postDescription.length
                                      : 0}
                                    {postDescription.length < 2000 &&
                                      ` / ${2000 - postDescription.length}`}
                                  </span>
                                  <button
                                    type="button"
                                    className="hover:opacity-70 transition-opacity"
                                    style={{
                                      fontSize: '18px',
                                      border: 'none',
                                      background: 'none',
                                      padding: '0',
                                      cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                      setShowEmojisMenu(!showEmojisMenu)
                                    }>
                                    😊
                                  </button>
                                </div>
                              </div>

                              {/* Emoji Picker */}
                              {showEmojisMenu && (
                                <div className="absolute z-50 shadow-lg">
                                  <Picker
                                    onEmojiClick={(e, emoji) => {
                                      const { selectionStart, selectionEnd } =
                                        textAreaCursorPostion;
                                      setShowEmojisMenu(false);
                                      let newMsg = postDescription.split('');
                                      newMsg.splice(
                                        selectionStart,
                                        selectionEnd - selectionStart,
                                        emoji.emoji
                                      );
                                      setPostDescription(newMsg.join(''));
                                    }}
                                  />
                                </div>
                              )}

                              <textarea
                                ref={message}
                                onClick={() => {
                                  if (message.current) {
                                    const { selectionStart, selectionEnd } =
                                      message.current;
                                    setTextAreaCursorPostion({
                                      selectionStart,
                                      selectionEnd
                                    });
                                  }
                                }}
                                onChange={(e) => {
                                  if (message.current) {
                                    message.current.className =
                                      'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none';
                                  }
                                  if (
                                    !message.current?.value ||
                                    message.current.value.length <= 2000
                                  ) {
                                    setPostDescription(e.target.value);
                                    setTextAreaCursorPostion({
                                      selectionStart: e.target.value.length,
                                      selectionEnd: e.target.value.length
                                    });
                                  }
                                }}
                                onFocus={() => setShowEmojisMenu(false)}
                                value={postDescription}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                                rows="4"
                                placeholder="Write your post message here..."
                                required
                                onDragOver={(e) => onDragOver(e)}
                                onDrop={(e) => onDrop(e)}
                              />

                              {/* Quick Insert Variables */}
                              <div className="mt-2.5">
                                <label
                                  className="text-gray-500 mb-1.5 block"
                                  style={{ fontSize: '11px' }}>
                                  Quick insert variables:
                                </label>
                                <div className="flex flex-wrap gap-1.5">
                                  {mergeFields}
                                </div>
                              </div>
                            </div>

                            {/* Instagram Tags Section - Inside same card */}
                            {!isPromotional &&
                              props.currentClientSocialNetworks?.instagram && (
                                <>
                                  <div
                                    style={{
                                      borderTop: '1px solid #e5e7eb',
                                      margin: '0 -16px',
                                      marginBottom: '16px'
                                    }}></div>
                                  <div>
                                    <div className="flex items-center justify-between mb-3">
                                      <div className="flex items-baseline gap-2">
                                        <i
                                          className="fab fa-instagram"
                                          style={{
                                            fontSize: '17px',
                                            color: '#3766a8',
                                            display: 'inline-flex',
                                            alignItems: 'center'
                                          }}></i>
                                        <h3
                                          className="font-semibold text-gray-900"
                                          style={{ fontSize: '17px' }}>
                                          # Instagram Tags
                                        </h3>
                                      </div>
                                      <button
                                        type="button"
                                        ref={btnTagRef}
                                        className="px-3 py-1.5 text-white rounded-lg hover:bg-blue-700 transition-colors"
                                        style={{
                                          fontSize: '12px',
                                          backgroundColor: '#3766a8',
                                          border: 'none'
                                        }}>
                                        Use default tags
                                      </button>
                                    </div>
                                    <IGTagsPost
                                      btnTagRef={btnTagRef}
                                      tagsPhrasesRef={tagsPhrasesRef}
                                      size="smaller"
                                      idClient={props['currentClientId']}
                                      tagsPost={tagsig}
                                      isIgActive={
                                        props.currentClientSocialNetworks
                                          ?.instagram
                                      }
                                    />
                                  </div>
                                </>
                              )}
                          </div>

                          {/* Publish Settings + Schedule Post */}
                          <div
                            className="bg-white border border-gray-200 p-4"
                            style={{ borderRadius: '12px' }}>
                            {/* Publish Settings Section */}
                            <div className="flex items-baseline gap-2.5 mb-3">
                              <i
                                className="fas fa-share-alt"
                                style={{
                                  fontSize: '17px',
                                  color: '#3766a8',
                                  display: 'inline-flex',
                                  alignItems: 'center'
                                }}></i>
                              <h3
                                className="font-semibold text-gray-900"
                                style={{ fontSize: '17px' }}>
                                Publish Settings
                              </h3>
                            </div>

                            <div className="mb-4">
                              <h4
                                className="font-medium text-gray-700 mb-3"
                                style={{ fontSize: '14px' }}>
                                Social Networks
                              </h4>
                              {!isPromotional && renderSocialNetworks()}
                            </div>

                            {props.currentClientSocialNetworks
                              .googleMyBusiness && (
                              <>
                                <div
                                  style={{
                                    borderTop: '1px solid #e5e7eb',
                                    margin: '0 -16px 16px -16px'
                                  }}></div>
                                <div className="grid grid-cols-2 gap-4 mb-4">
                                  <div className="flex items-center justify-between">
                                    <span
                                      className="text-gray-700"
                                      style={{ fontSize: '14px' }}>
                                      Add Offer
                                    </span>
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        onChange={handleOfferSwitchChange}
                                        checked={isOffer}
                                      />
                                      <span className="slider round" />
                                    </label>
                                  </div>

                                  <div className="flex items-center justify-between">
                                    <span
                                      className="text-gray-700"
                                      style={{ fontSize: '14px' }}>
                                      Google Post
                                    </span>
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        onChange={() => {
                                          setIsPromotional(!isPromotional);
                                          !isCustomTime && handleCustomTime();
                                          isPromotional &&
                                            isCustomTime &&
                                            handleCustomTime();
                                          !isCustomTime &&
                                            !checked &&
                                            handleRecurrentCheck();
                                        }}
                                        checked={isPromotional}
                                      />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* Schedule Post Section - Inside same card */}
                            <div
                              style={{
                                borderTop: '1px solid #e5e7eb',
                                margin: '0 -16px 16px -16px',
                                paddingTop: '16px',
                                paddingLeft: '16px',
                                paddingRight: '16px'
                              }}>
                              <div
                                style={{
                                  pointerEvents: post.isRepairingPost
                                    ? 'none'
                                    : 'auto',
                                  opacity: post.isRepairingPost ? 0.5 : 1
                                }}>
                                <div className="flex items-center justify-between mb-3">
                                  <div className="flex items-baseline gap-2.5">
                                    <i
                                      className="far fa-calendar"
                                      style={{
                                        fontSize: '17px',
                                        color: '#3766a8',
                                        display: 'inline-flex',
                                        alignItems: 'center'
                                      }}></i>
                                    <h3
                                      className="font-semibold text-gray-900"
                                      style={{ fontSize: '17px' }}>
                                      Schedule Post
                                    </h3>
                                  </div>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      onChange={() => handleCustomTime()}
                                      checked={isCustomTime}
                                    />
                                    <span className="slider round" />
                                  </label>
                                </div>

                                {isCustomTime && (
                                  <div className="space-y-3">
                                    <div>
                                      <label
                                        className="block text-gray-600 mb-2"
                                        style={{ fontSize: '13px' }}>
                                        Please select date and time
                                      </label>
                                      <DateTimePicker
                                        onChange={onChange}
                                        disableClock
                                        value={date}
                                        minDate={getTime(currentClientTimeZone)}
                                        name="postSchedule"
                                        required
                                        showTime={{ use12Hours: true }}
                                        format="dd/MM/yyyy hh:mm a"
                                        clearIcon={null}
                                        calendarIcon={null}
                                        className="w-full"
                                      />
                                    </div>

                                    {date &&
                                      typeof date !== 'number' &&
                                      props.currentClientBestTimes &&
                                      getTime(
                                        currentClientTimeZone
                                      ).getHours() >
                                        parseInt(
                                          props.currentClientBestTimes[
                                            days[date.getDay()]
                                          ]
                                        ) &&
                                      date.getDate() ===
                                        new Date().getDate() && (
                                        <div className="flex items-center gap-2 text-xs text-amber-600 bg-amber-50 px-3 py-2 rounded">
                                          <i className="fas fa-exclamation-triangle" />
                                          <span>
                                            Your best time posting has passed
                                          </span>
                                        </div>
                                      )}

                                    <label className="flex items-center space-x-3 cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        id="recurrentCheck"
                                        onChange={handleRecurrentCheck}
                                        checked={checked}
                                      />
                                      <span className="text-sm text-gray-700">
                                        Recurring post
                                      </span>
                                    </label>

                                    {showRecurrent && (
                                      <RecurrentPosts
                                        date={date}
                                        recurrentDates={(dates) =>
                                          setRecurrentDates(
                                            editTimeRecurrentDates(
                                              dates,
                                              currentClientTimeZone
                                            )
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                )}

                                {!isCustomTime && bestTime && (
                                  <div className="text-center py-4">
                                    <div className="text-sm text-gray-500 mb-1">
                                      Best time to post
                                    </div>
                                    <div className="text-2xl font-semibold text-gray-900">
                                      {bestTime.toLocaleString('en-US', {
                                        hour: 'numeric',
                                        minute: 'numeric',
                                        hour12: true
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Columna Derecha */}
                        <div className="space-y-4">
                          {/* Image Preview */}
                          <div
                            className="bg-white border border-gray-200 p-4"
                            style={{ borderRadius: '12px' }}>
                            <div className="flex items-baseline gap-2.5 mb-3">
                              <i
                                className="far fa-image"
                                style={{
                                  fontSize: '17px',
                                  color: '#3766a8',
                                  display: 'inline-flex',
                                  alignItems: 'center'
                                }}></i>
                              <h3
                                className="font-semibold text-gray-900"
                                style={{ fontSize: '17px' }}>
                                Image Preview
                              </h3>
                            </div>

                            <div
                              className="relative bg-gray-50 border-2 border-dashed border-gray-300 flex items-center justify-center mb-4"
                              style={{ borderRadius: '10px', height: '200px' }}>
                              {croppedImg || preview ? (
                                <>
                                  <img
                                    src={croppedImg || preview}
                                    alt="Preview"
                                    className="w-full h-full object-cover rounded-lg"
                                  />
                                  {preview && (
                                    <button
                                      onClick={() => setShowImgEditModal(true)}
                                      className="absolute bottom-2 right-2 p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-all"
                                      style={{ border: '2px solid #3766a8' }}>
                                      <i
                                        className="fa fa-pencil-alt"
                                        style={{
                                          color: '#3766a8',
                                          fontSize: '14px'
                                        }}></i>
                                    </button>
                                  )}
                                </>
                              ) : (
                                <div className="text-center">
                                  <i className="far fa-image text-gray-400 text-4xl mb-2"></i>
                                  <p className="text-sm text-gray-500">
                                    No image selected
                                  </p>
                                </div>
                              )}
                            </div>

                            {hasSelectedImage && (croppedImg || preview) && (
                              <button
                                type="button"
                                className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${
                                  isGeneratingText
                                    ? 'bg-gray-100 text-gray-500'
                                    : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                                }`}
                                onClick={generateTextFromImage}
                                disabled={isGeneratingText}>
                                {isGeneratingText ? (
                                  <>
                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                    Generating...
                                  </>
                                ) : (
                                  <>
                                    <i className="fa fa-magic mr-2"></i>
                                    Generate Post
                                  </>
                                )}
                              </button>
                            )}
                          </div>

                          {/* Select Image */}
                          <div
                            className="bg-white border border-gray-200 p-4"
                            style={{ borderRadius: '12px' }}>
                            <h3
                              className="font-semibold text-gray-900 mb-3"
                              style={{ fontSize: '17px' }}>
                              Select Image
                            </h3>

                            <div
                              style={{
                                borderRadius: '8px',
                                overflow: 'hidden',
                                border: '1px solid #e5e7eb'
                              }}>
                              {!isPromotional ? (
                                <SearchContext.Provider
                                  value={{ query, setQuery }}>
                                  <TabMenu state={{ value, handleIndexChange }}>
                                    <UserGallery
                                      setAppImage={setAppImage}
                                      checkImg={checkImg}
                                      userId={props.currentClientId}
                                      refresh={refresh}
                                    />
                                    <ContentGallery
                                      setAppImage={setAppImage}
                                      userId={props.currentClientId}
                                      refresh={refresh}
                                    />
                                    <ClientGallery
                                      setAppImage={setAppImage}
                                      userId={props.currentClientId}
                                      refresh={refresh}
                                    />
                                    <GoogleBusinessGallery
                                      setAppImage={handleSelectImage}
                                      userId={props.currentClientId}
                                      refresh={refresh}
                                    />
                                    <YelpGallery
                                      setAppImage={handleSelectImage}
                                      userId={props.currentClientId}
                                      refresh={refresh}
                                    />
                                    <Freepik setAppImage={setAppImage} />
                                    <Pixabay setAppImage={setAppImage} />
                                  </TabMenu>
                                </SearchContext.Provider>
                              ) : (
                                <GoogleGallery
                                  setAppImage={setAppImage}
                                  userId={props.currentClientId}
                                  refresh={refresh}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>

                  {/* Edit Image Modal */}
                  {showImgEditModal && (
                    <EditImgModal
                      img={preview}
                      storeOriginal={(img) => setImgurlig(img)}
                      handleClose={() => setShowImgEditModal(false)}
                      onUpdate={(img) => setCroppedImg(img)}
                      clientId={props.currentClientId}
                    />
                  )}

                  {/* Offer Modal */}
                  {isAuthenticated &&
                    (currentRole === 'superAdmin' ||
                      allowedEmails.includes(currentEmail)) &&
                    isOffer && (
                      <OfferModal
                        onClose={() => {
                          setIsOffer(false);
                          setIsOriginalVisible(true);
                        }}
                        onBack={() => {
                          setIsOffer(false);
                          setIsOriginalVisible(true);
                        }}
                        props={props}
                      />
                    )}
                </div>
              </div>
            </div>

            {/* Offer Modal */}
            {isAuthenticated &&
              (currentRole === 'superAdmin' ||
                allowedEmails.includes(currentEmail)) &&
              isOffer && (
                <OfferModal
                  onClose={() => {
                    setIsOffer(false);
                    setIsOriginalVisible(true);
                  }}
                  onBack={() => {
                    setIsOffer(false);
                    setIsOriginalVisible(true);
                  }}
                  props={props}
                />
              )}

            {/* Dialog Modals */}
            <Dialog
              open={imageTooSmallModalOpen}
              onOpenChange={setImageTooSmallModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    Your image is too small ({imageDimensions.width} x{' '}
                    {imageDimensions.height}), should be at least 800 x 600
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setImageTooSmallModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={postSentSuccessModalOpen}
              onOpenChange={(open) => {
                setPostSentSuccessModalOpen(open);
                if (!open) {
                  if (modalDismiss.current) modalDismiss.current.click();
                  if (props?.callbackClose) props.callbackClose();
                }
              }}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Success!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    Your post has been sent
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => {
                      setPostSentSuccessModalOpen(false);
                      if (modalDismiss.current) modalDismiss.current.click();
                      if (props?.callbackClose) props.callbackClose();
                    }}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={postErrorModalOpen}
              onOpenChange={setPostErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    We have trouble adding the publication
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setPostErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={noMessageErrorModalOpen}
              onOpenChange={setNoMessageErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    Please add a message
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setNoMessageErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={messageValidationErrorModalOpen}
              onOpenChange={setMessageValidationErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    {validationErrorMessage}
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setMessageValidationErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={noImageErrorModalOpen}
              onOpenChange={setNoImageErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    Please add a image
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setNoImageErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={noImageSelectedErrorModalOpen}
              onOpenChange={setNoImageSelectedErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    No image selected to generate text
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setNoImageSelectedErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={textGenerationErrorModalOpen}
              onOpenChange={setTextGenerationErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    The text could not be generated automatically.
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setTextGenerationErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
              open={invalidUrlErrorModalOpen}
              onOpenChange={setInvalidUrlErrorModalOpen}>
              <DialogContent className="sm:max-w-md text-center py-10">
                <DialogHeader className="items-center">
                  <DialogTitle className="text-2xl font-bold text-foreground">
                    Error!
                  </DialogTitle>
                  <DialogDescription className="text-base text-muted-foreground mt-2">
                    The url is not valid!
                  </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center mt-4">
                  <DialogButton
                    className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
                    onClick={() => setInvalidUrlErrorModalOpen(false)}>
                    OK
                  </DialogButton>
                </div>
              </DialogContent>
            </Dialog>
          </>,
          document.body
        )}
    </>
  );
});

const fileToBase64 = (file, callBack) => {
  file = file.files[0];
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = function () {
    callBack(reader.result);
  };
  reader.onerror = function (error) {
    console.error('Error: ', error);
  };
};

const blobToBase64 = (blob, callBack) => {
  let xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = function () {
    let recoveredBlob = xhr.response;
    let reader = new FileReader();
    reader.onload = function () {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.error('Error: ', error);
    };
    reader.readAsDataURL(recoveredBlob);
  };
  xhr.open('GET', blob);
  xhr.send();
};

export default NewPost;
